import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { DASHBOARD_BASE_URL, printDebugLog, SUCCESS, WidgetType } from "../../constants/Constants";
import axios from "axios";
import { BOOKINGRIGHTS } from "../../constants/Permissions";

const Widget = ({ shopHash, type, isRoleAllowed }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [variableData, setVariableData] = useState(null);

  let data = {};

  const dashboardBookingCount = async (isBanquet) => {
    try {
      setLoading(true);
      const mUrl = `${DASHBOARD_BASE_URL}dashboard-booking-count?shopHash=${shopHash}&banquet=${isBanquet}`;
      const response = await axios.get(mUrl);
      printDebugLog("dashboardBookingCount=>", response);
      if (response.data.status === SUCCESS) {
        setVariableData({
          todaysBookingCount: response.data.payLoad.todaysBookingCount,
          todaysCheckInCount: response.data.payLoad.todaysCheckInCount,
          todaysCheckOutCount: response.data.payLoad.todaysCheckOutCount,
          totalBookingCount: response.data.payLoad.totalBookingCount,
        });
      }
    } catch (error) {
      console.error("dashboardBookingCount ", isBanquet, error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (type === WidgetType.BOOK_ROOM) {
      dashboardBookingCount(false);
    } else if (type === WidgetType.BOOK_BANQUET) {
      dashboardBookingCount(true);
    }
  }, [type, shopHash]);

  switch (type) {
    case WidgetType.OWNER_DASHBOARD:
      data = {
        title: "Owner Dashboard",
        link: "Check details",
        navigate: "/dashboard",
      };
      break;
    case WidgetType.BOOK_ROOM:
      data = {
        title: "Book Room",
        link: "Click here to book room",
        navigate: "/bookroom",
      };
      break;
    case WidgetType.BOOK_BANQUET:
      data = {
        title: "Book Banquet",
        link: "View all bookings",
        navigate: "/bookbanquet",
      };
      break;
    case WidgetType.SHOW_BOOKINGS:
      data = {
        title: "Show Bookings",
        link: "View all bookings",
        navigate: "/showbookings",
      };
      break;
    default:
      break;
  }

  return (
    <div className="widget">
      <div className="widget-left">
        <span className="widget-title">{data.title}</span>
        {
          loading && <CircularProgress color="secondary"
          />}
        {variableData && (
          <>
            <span className="widget-counter">
              Today's Booking count: {variableData?.todaysBookingCount ?? 0}
            </span>
            <span className="widget-counter">
              Today's Checkin: {variableData?.todaysCheckInCount ?? 0}
            </span>
            <span className="widget-counter">
              Today's Checkout: {variableData?.todaysCheckOutCount ?? 0}
            </span>
            <span className="widget-counter">
              Total Live Booking count: {variableData?.totalBookingCount ?? 0}
            </span>
          </>
        )}
        <span className="widget-link" onClick={() => {
          if (data.type === Widget.BOOK_ROOM || data.type === Widget.BOOK_BANQUET) {
            if (isRoleAllowed(BOOKINGRIGHTS)) {
              navigate(data.navigate);
            }
          } else {
            navigate(data.navigate);
          }
        }}>
          {data.link}
        </span>
      </div>
    </div>
  );
};

export default Widget;
